// /opt/isp_erp/frontend/src/components/tickets/ChangeAvailabilityDialog.jsx
import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Alert,
  Box,
  Typography,
  Chip,
  CircularProgress
} from '@mui/material';
import axios from '../../api/axios';

const availabilityOptions = [
  { value: 'DISPONIBLE', label: '🟢 Disponible', color: 'success' },
  { value: 'OCUPADO', label: '🟡 Ocupado', color: 'warning' },
  { value: 'PERMISO_SOLICITADO', label: '🔵 Permiso Solicitado', color: 'info' },
  { value: 'PERMISO_APROBADO', label: '🟢 Permiso Aprobado', color: 'success' },
  { value: 'PERMISO_RECHAZADO', label: '🔴 Permiso Rechazado', color: 'error' }
];

export default function ChangeAvailabilityDialog({ open, onClose, technician, onSuccess }) {
  const [estado, setEstado] = useState('');
  const [motivo, setMotivo] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    if (!estado) {
      setError('Debe seleccionar un estado');
      return;
    }

    setLoading(true);
    setError('');

    try {
      await axios.post(`/tickets/tecnicos/${technician.id}/cambiar-disponibilidad`, {
        estado: estado,
        motivo: motivo || null
      });

      onSuccess();
      onClose();
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al cambiar disponibilidad');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Cambiar Disponibilidad
        <Typography variant="body2" color="text.secondary">
          Técnico: {technician?.username || technician?.id}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Estado de Disponibilidad</InputLabel>
            <Select
              value={estado}
              onChange={(e) => setEstado(e.target.value)}
              label="Estado de Disponibilidad"
            >
              {availabilityOptions.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                  <Chip label={opt.label} color={opt.color} size="small" sx={{ mr: 1 }} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            fullWidth
            label="Motivo (opcional)"
            value={motivo}
            onChange={(e) => setMotivo(e.target.value)}
            multiline
            rows={3}
            placeholder="Ej: Permiso médico, Capacitación, Descanso, etc."
          />

          {estado === 'PERMISO_SOLICITADO' && (
            <Alert severity="info" sx={{ mt: 2 }}>
              El técnico ha solicitado permiso. Debe ser aprobado por un supervisor o administrador.
            </Alert>
          )}

          {estado === 'PERMISO_RECHAZADO' && (
            <Alert severity="warning" sx={{ mt: 2 }}>
              El permiso ha sido rechazado. El técnico debe estar disponible para trabajar.
            </Alert>
          )}

          {estado === 'OCUPADO' && (
            <Alert severity="warning" sx={{ mt: 2 }}>
              El técnico está ocupado. No se le asignarán nuevos tickets hasta que cambie su estado.
            </Alert>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancelar
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={loading || !estado}
        >
          {loading ? <CircularProgress size={24} /> : 'Guardar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
